module.exports = __webpack_public_path__ + "static/media/arrow-return.3607d159.svg";